(ns rlws.iot-cloud.frontend.sse
  (:require [rlws.iot-cloud.frontend.common :as common]
            [rlws.iot-cloud.frontend.config :as config]
            [re-frame.core :as rf]
            [vimsical.re-frame.cofx.inject :as inject]))

(rf/reg-fx
 ::add-listener
 (fn [sse-endpoint]
   (let [es (js/EventSource. sse-endpoint)]
     (rf/dispatch [::register-event-source es])
     (.addEventListener es "message" #(rf/dispatch [::handle-event %])))))

(rf/reg-event-db
 ::register-event-source
 (fn [db [_ es]]
   (assoc db :event-source es)))

(rf/reg-event-fx
 ::handle-event
 (fn [{:keys [_db]} [_ e]]
   (let [data (dissoc (common/json->cljs (.-data e)) :audience)
         message (:message data)
         event (cond
                 (string? message)
                 (keyword message)
                 (vector? message)
                 (apply keyword message)
                 :else
                 ;;do nothing
                 :heartbeat)]
     (when-let [dispatch (event config/sse-event-whitelist)]
       {:dispatch [dispatch (:data data)]}))))

(defn close-sse-connection
  [db]
  (when-let [es (:event-source db)]
    (try
      (.close es)
      (catch js/Error e
        (js/console.error "Couldn't close SSE connection")
        (js/console.error es)
        (js/console.error e)))))

(rf/reg-event-fx
 ::close
 (fn [{:keys [db]} _]
   (close-sse-connection db)))

(rf/reg-event-fx
 ::listen
 (rf/inject-cofx ::inject/sub [:rlws.iot-cloud.frontend.subscriptions/current-user])
 (fn [{:keys [db :rlws.iot-cloud.frontend.subscriptions/current-user]} _]
   (close-sse-connection db)
   (let [{:keys [roles dealership customer]} current-user
         superuser? (contains? (set roles) "superuser")
         sse-endpoint (if superuser?
                        (str config/state-api-origin "/events")
                        (str config/state-api-origin "/events"
                             "?dealership=" dealership
                             (when customer
                               (str "&customer=" customer))))]
     {::add-listener sse-endpoint})))
